const burger = document.getElementById('burger');
const menu = document.getElementById('menu');

if(burger && menu) {
    burger.addEventListener('click', () => {
        if(burger.classList.contains('open')) {
            burger.classList.remove('open');
            menu.classList.remove('open');
        } else {
            burger.classList.add('open');
            menu.classList.add('open');
        }
    });
}

